import { IValidationError } from '@/Framework/UI/Organisms/FinalForm/validators/interfaces/ValidationError';

interface IParams {
  value: string,
  fieldName: string,
  fieldCaption: string,
}

export const validateNumberWithLeadingZero = (params: IParams): IValidationError => {
  const { value, fieldName, fieldCaption } = params;

  if (value && /^0[0-9]+$/.test(value)) {
    return {
      [fieldName]: `${ fieldCaption || 'Field' } cannot start with a zero`,
    };
  }

  return null;
};
